// extracted by mini-css-extract-plugin
export default {"block":"plan-details-and-usage_block__CbGjQ"};